/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchAgentsResponse } from './search-agents-response';


export interface SearchAgentsResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchAgentsResponse> | null;
}

